import { useEffect, useLayoutEffect, useState } from "react";
import { Switch, Typography, TextField, Box, Card, Snackbar, Alert } from "@mui/material";

import WDBox from "../../../MaterialComponents/WDBox";
import BasicLayout from "../../../LayoutContainers/BasicLayout";
import WDButton from "../../../MaterialComponents/WDButton";
import WDTypography from "../../../MaterialComponents/WDTypography";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import axios from 'axios';
import AppService from "../../../Configurations/Appservice";
import { formCard, formPanel, header, rightPanel, rootBox } from "./styles";
import pxToRem from "../../../Themes/Functions/pxToRem";
import logo from "../../../assets/images/Logo.jpeg";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch } from "react-redux";
import { updateAuthInfo } from "../../../LayoutContainers/AppLayout/redux/AppSlice";

const LoginPage = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();

  const [showError, setShowError] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowError(false);
  };

  // const authInfo = localStorage.getItem("authInfo");
  // if (authInfo) {
  //   alert("hello");
  //   navigate("ADM-Dash/customer");
  // }
  // useEffect(() => {
  //   const authInfo = localStorage.getItem("authInfo");
  //   console.log(authInfo);
  //   navigate("ADM-Dash/customer");
  // }, []);

  const initialValues = {
    userName: "",
    password: "",
  };

  const validationSchema = object({
    userName: string().required("User Name is Mandatory"),
    password: string().required("Password is Mandatory"),
  });

  const [isRememberMe, rememberMe] = useState(false);
  const [isLoading, loading] = useState(false);

  const [errorMessage, setErrorMessage] = useState();

  const _loginHandler = (values, formikHelpers) => {
    // Completely clear all tokens and auth data before login to prevent token mixing
    console.log('Clearing all tokens and auth data before login');
    
    // Clear all potential token storage locations
    ['token', 'jwt_token', 'refresh_token', 'authToken', 'authInfo', 'organizationId'].forEach(key => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    
    // Also clear axios default header if present
    if (axios?.defaults?.headers?.common?.['Authorization']) {
      delete axios.defaults.headers.common['Authorization'];
    }
    
    loading(true);
    AppService.post("/api/auth/login", values)
      .then((response) => {
        console.log(response);
        sessionStorage.setItem("authInfo", JSON.stringify(response));
        localStorage.setItem("authInfo", JSON.stringify(response));
        
        // Store organization ID separately for easy access
        if (response.principalInfo && response.principalInfo.organisationId) {
          console.log('Storing organization ID in localStorage:', response.principalInfo.organisationId);
          localStorage.setItem("organizationId", response.principalInfo.organisationId);
        }
        
        dispatch(updateAuthInfo(response));
        _navigateToApp(response);
      })
      .catch((error) => {
        
        let message = "Login failed ,Please try again";
        if(error.response){
          if(error.response.data?.message){
            message = error.response.data.message;
          }
          else if(typeof error.response.data === "string"){
            message = error.response.data;
          }
          else{
            message = error.response.statusText || message;
          }
        }
        setErrorMessage(message);
        setShowError(true);
      })
      .finally(() => {
        loading(false);
      });
  };

  const _navigateToApp = (response) => {
    loading(false);
    if (response.principalInfo.userType === "ADMIN_ORG") {
      navigate("ADM-Dash/customer");
    } else if (response.principalInfo.userType === "PARTNER_ORG" || response.principalInfo.userType === "CHANNEL_PARTNER_ORG") {
      navigate("ptr/dash");
    } else if (response.principalInfo.userType === "CUSTOMER_ORG") {
      // Redirect customer organization users to the new dashboard URL
      navigate("cst/dash/documents");
      console.log("[Login] Customer organization user redirected to cst/dash/documents");
    } else {
      // Fallback for any other user types
      navigate("CST-Dashboard");
    }
  };

    return (
      <BasicLayout>
        <Snackbar open={showError} autoHideDuration={2000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
            {errorMessage}
          </Alert>
        </Snackbar>

        <Box sx={rootBox}>
          <Box sx={formPanel}>
            <Typography color="white.main" sx={{ my: 2 }}>
              Login To Your Account
            </Typography>
            <Box sx={formCard}>
              <Formik
                initialValues={initialValues}
                onSubmit={_loginHandler}
                validationSchema={validationSchema}
              >
                {({ errors, isValid, touched, dirty }) => (
                  <Form>
                    <WDBox mb={2}>
                      <Field
                        name="userName"
                        label="User Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.userName) && Boolean(touched.userName)}
                        helperText={Boolean(touched.userName) && errors.userName}
                        inputProps={{ style: { color: "white" } }}
                      />
                    </WDBox>
                    <WDBox mb={2}>
                      <Field
                        name="password"
                        label="Password"
                        fullWidth
                        type={showPassword ? "text" : "password"}
                        as={TextField}
                        error={Boolean(errors.password) && Boolean(touched.password)}
                        helperText={Boolean(touched.password) && errors.password}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword((state) => !state)}
                              >
                                {showPassword ? (
                                  <Visibility fontSize="small" color="white" />
                                ) : (
                                  <VisibilityOff fontSize="small" color="white" />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        inputProps={{
                          style: { color: "white" },
                        }}
                      />
                    </WDBox>
                    {/* <WDBox display="flex" alignItems="center" ml={-1} mb={3}>
                  <Switch
                    checked={isRememberMe}
                    onChange={() => rememberMe((value) => !value)}
                    disabled={isLoading}
                  />
                  <WDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none" }}
                  >
                    Remember me
                  </WDTypography>
                </WDBox> */}
                    <WDButton
                      variant="contained"
                      fullWidth
                      disabled={!dirty || !isValid}
                      type="submit"
                      sx={{ 
                        backgroundColor: '#064d51 !important',
                        '&:hover': { backgroundColor: '#053a3d !important' },
                        color: 'white',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        padding: '10px 0',
                        borderRadius: '4px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'                       
                      }}
                    >
                      {isLoading ? "Login..." : "Login"}
                    </WDButton>
                    <Typography
                      variant="body2"
                      sx={{ mt: 2, textAlign: "center", cursor: "pointer", color: "white.main" }}
                      onClick={() => navigate("/forgot-password")}
                    >
                      Forgot your password?
                    </Typography>
                  </Form>
                )}
              </Formik>
            </Box>{" "}
          </Box>
          <Box sx={rightPanel}>
            <Box component="img" src={logo} sx={{ height: "30%", width: "auto" }} />
            {/* <img src={logo} sx={{ height: 10, width: 10 }} /> */}
          </Box>
        </Box>
      </BasicLayout>
    );
};

export default LoginPage;
